<template>
  <div
    class="max-w-46 ml-auto flex h-9 cursor-pointer items-center rounded-md border border-white bg-white px-2"
    @click="openSearchPalette"
  >
    <div class="flex items-center justify-between">
      <FontAwesomeIcon
        :icon="faMagnifyingGlass"
        class="mr-2 size-4 text-gray-400"
        aria-hidden="true"
      />
      <SpectreText
        as="span"
        class="mr-1"
        size="sm"
        weight="medium"
        color="secondary"
      >
        Search
      </SpectreText>
      <Transition
        name="slide-fade"
        mode="out-in"
      >
        <SpectreText
          :key="currentWord"
          as="span"
          class="w-12"
          size="sm"
          weight="medium"
          color="secondary"
        >
          {{ currentWord }}
        </SpectreText>
      </Transition>
    </div>

    <Keyboard class="ml-6">
      /
    </Keyboard>
  </div>
</template>
<script setup lang="ts">
import { SpectreText } from '@agentsoftware/spectre-ui';
import useGlobalSearch from '@/Composables/useGlobalSearch';
import { onMounted, onUnmounted, ref } from 'vue';
import Keyboard from '@/Components/Shared/Keyboard.vue';
import { faMagnifyingGlass } from '@awesome.me/kit-644ec404bf/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const { openSearchPalette } = useGlobalSearch();
const words = ['accounts', 'users', 'companies', 'anything'];
const currentWord = ref(words[0]);

let wordIndex = 0;
let intervalId: any;

const rotateWords = () => {
  wordIndex = (wordIndex + 1) % words.length;
  currentWord.value = words[wordIndex];

  if (wordIndex === 0) {
    currentWord.value = '...';
    clearInterval(intervalId);
  }
};

onMounted(() => {
  intervalId = setInterval(rotateWords, 1000);
});

onUnmounted(() => {
  if (intervalId) {
    clearInterval(intervalId);
  }
});
</script>
<style scoped>
.slide-fade-enter-active {
  transition: all .1s ease;
}

.slide-fade-leave-active {
  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(4px);
  opacity: 0;
}
</style>
